{
  "version": 1,
  "asset_id": "6f663b24-95c7-47a4-a03f-7b033784989b",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/6f663b24-95c7-47a4-a03f-7b033784989b/clip-img_2031-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/6f663b24-95c7-47a4-a03f-7b033784989b/clip-img_2031-poster-sm.webp",
  "original_filename": "clip-img_2031-poster-sm.webp",
  "size": 15992,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:20Z"
}
